import Box from '@mui/material/Box';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { COLORS } from '@traton/common-ui';

interface AnnouncementSeverityIconProps {
  criticality: string;
}

export const AnnouncementSeverityIcon = ({
  criticality,
}: AnnouncementSeverityIconProps) => {
  let icon = <InfoOutlinedIcon sx={{ fontSize: '24px' }} />;
  if (criticality === 'critical') {
    icon = <ErrorOutlineIcon sx={{ fontSize: '24px' }} />;
  } else if (criticality === 'warning') {
    icon = <WarningAmberIcon sx={{ fontSize: '24px' }} />;
  }

  return (
    <Box
      sx={{
        color: COLORS.light.TRATON_White,
        flexShrink: 0,
        display: 'flex',
        pt: '2px',
      }}
    >
      {icon}
    </Box>
  );
};
